import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import MuiTooltip, { TooltipProps } from '@material-ui/core/Tooltip'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import * as BrowserDetect from '../../utilities/browserDetect'

type TooltipViewType = TooltipType & {
    open: boolean
    onTooltipOpen: () => void
    onClickTooltipClose: () => void
}

const TooltipView: React.FC<TooltipViewType> = (props) => {
    const { open, title, placement = 'bottom', onTooltipOpen, onClickTooltipClose } = props
    const isMobileTablet = BrowserDetect.mobileAndTabletCheck()
    const classes = useStyles()

    const mobileView = (
        <ClickAwayListener onClickAway={onClickTooltipClose}>
            <MuiTooltip
                title={title}
                arrow
                placement={placement}
                open={open}
                PopperProps={{
                    disablePortal: true,
                }}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                onClose={onClickTooltipClose}
                classes={{ tooltip: classes.tooltip, arrow: classes.tooltip_arrow }}
            >
                <span onClick={onTooltipOpen}>{props.children}</span>
            </MuiTooltip>
        </ClickAwayListener>
    )

    const webView = (
        <MuiTooltip
            title={title}
            arrow
            placement={placement}
            classes={{ tooltip: classes.tooltip, arrow: classes.tooltip_arrow }}
        >
            <span>{props.children}</span>
        </MuiTooltip>
    )

    return (isMobileTablet && mobileView) || webView
}

type TooltipType = {
    title: TooltipProps['title']
    placement?: TooltipProps['placement']
}
const Tooltip: React.FC<TooltipType> = (props) => {
    const [open, setOpen] = React.useState(false)

    const handleTooltipOpen = () => {
        setOpen(true)
    }
    const handleClickTooltipClose = () => {
        setOpen(false)
    }
    return (
        <TooltipView
            {...props}
            open={open}
            onTooltipOpen={handleTooltipOpen}
            onClickTooltipClose={handleClickTooltipClose}
        />
    )
}

export default Tooltip

const useStyles = makeStyles((theme) => ({
    tooltip: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '16px',
        boxShadow: 'rgb(0 0 0 / 35%) 0px 5px 15px',
        backgroundColor: 'white',
        color: theme.palette.text.primary,
        padding: '10px',
    },
    tooltip_arrow: {
        '&::before': {
            // boxShadow: 'rgb(0 0 0 / 35%) 0px 5px 15px',
            backgroundColor: 'white',
        },
    },
}))
